// extracted by mini-css-extract-plugin
export default {"mandatoryColor":"SchedaSpecialeTubercolosi_mandatoryColor__oFOXV"};